import { handleAuthResponse } from '../auth';

export const create = (userId, token, forumpostdata) => {
    return fetch(`${process.env.REACT_APP_API_URL}/forumpost/new/${userId}`, {
        method: "POST",
        credentials: 'include',
        headers: {
            Accept: "application/json",
        },
        body: forumpostdata
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};


// with pagination
export const list = page => {
    return fetch(`${process.env.REACT_APP_API_URL}/forumposts/?page=${page}`, {
        method: "GET",
        credentials: 'include'
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

// with pagination
export const listByGroup = (groupId, page) => {
    return fetch(`${process.env.REACT_APP_API_URL}/forumpostsbygroup/${groupId}?page=${page}`, {
        method: "GET",
        credentials: 'include'
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const singleForumPost = forumpostId => {
    return fetch(`${process.env.REACT_APP_API_URL}/forumpost/${forumpostId}`, {
        method: "GET",
        credentials: 'include'
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};



export const listByUser = (userId, token) => {
    return fetch(`${process.env.REACT_APP_API_URL}/forumposts/by/${userId}`, {
        method: "GET",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const getGroupLatestPost = (groupId) => {
    return fetch(`${process.env.REACT_APP_API_URL}/latestforumpostsbygroup/${groupId}`, {
        method: "GET",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};



export const getChairsLatestMessage = (userId) => {
    return fetch(`${process.env.REACT_APP_API_URL}/onetopforumposts/by/${userId}`, {
        method: "GET",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};


export const remove = (forumpostId, token) => {
    return fetch(`${process.env.REACT_APP_API_URL}/forumpost/${forumpostId}`, {
        method: "DELETE",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const update = (forumpostId, token, forumpost) => {
    console.log(forumpost)
    return fetch(`${process.env.REACT_APP_API_URL}/forumpost/${forumpostId}`, {
        method: "PUT",
        credentials: 'include',
        headers: {
            Accept: "application/json",
        },
        body: forumpost
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const like = (userId, token, forumpostId) => {
    return fetch(`${process.env.REACT_APP_API_URL}/forumpost/like`, {
        method: "PUT",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ userId, forumpostId })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const unlike = (userId, token, forumpostId) => {
    return fetch(`${process.env.REACT_APP_API_URL}/forumpost/unlike`, {
        method: "PUT",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ userId, forumpostId })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const comment = (userId, token, forumpostId, comment) => {
    return fetch(`${process.env.REACT_APP_API_URL}/forumpost/comment`, {
        method: "PUT",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ userId, forumpostId, comment })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const uncomment = (userId, token, forumpostId, comment) => {
    return fetch(`${process.env.REACT_APP_API_URL}/forumpost/uncomment`, {
        method: "PUT",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ userId, forumpostId, comment })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

